export const INVOICE_PAYED_ACTION = 'INVOICE_PAYED';
export const INVOICE_REFUND_ACTION = 'INVOICE_REFUND';
